<template>

    <div v-if="doctors" class="row">
        <div v-for="item in datas" :key="item" class="col-xl-3 col-lg-3 col-md-6 mt-4">
            <div class="card team border-0 rounded shadow overflow-hidden">
                <div class="team-img position-relative">
                    <img :src="item.image" class="img-fluid" alt="">
                    <ul class="list-unstyled team-social mb-0">
                        <li><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i data-feather="facebook"
                                    class="icons"></i></a></li>
                        <li class="mt-2"><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i
                                    data-feather="linkedin" class="icons"></i></a></li>
                        <li class="mt-2"><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i
                                    data-feather="github" class="icons"></i></a></li>
                        <li class="mt-2"><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i
                                    data-feather="twitter" class="icons"></i></a></li>
                    </ul>
                </div>
                <div class="card-body content text-center">
                    <a href="#" class="title text-dark h5 d-block mb-0">{{item.name}}</a>
                    <small class="text-muted speciality">{{item.position}}</small>
                </div>
            </div>
        </div><!--end col-->
    </div>


    <!-- Start -->
    <div v-else class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="section-title text-center mb-4 pb-2">
                    <h4 class="title mb-4">Doctors</h4>
                    <p class="text-muted mx-auto para-desc mb-0">Great doctor if you need your family member to get
                        effective immediate assistance, emergency treatment or a simple consultation.</p>
                </div>
            </div><!--end col-->
        </div><!--end row-->

        <div class="row align-items-center">
            <div v-for="item in datas.slice(0, 4)" :key="item" class="col-xl-3 col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team border-0 rounded shadow overflow-hidden">
                    <div class="team-img position-relative">
                        <img :src="item.image" class="img-fluid" alt="">
                        <ul class="list-unstyled team-social mb-0">
                            <li><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i data-feather="facebook"
                                        class="icons"></i></a></li>
                            <li class="mt-2"><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i
                                        data-feather="linkedin" class="icons"></i></a></li>
                            <li class="mt-2"><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i
                                        data-feather="github" class="icons"></i></a></li>
                            <li class="mt-2"><a href="#" class="btn btn-icon btn-pills btn-soft-primary"><i
                                        data-feather="twitter" class="icons"></i></a></li>
                        </ul>
                    </div>
                    <div class="card-body content text-center">
                        <router-link to="/doctor-team-one" class="title text-dark h5 d-block mb-0">{{ item.name
                            }}</router-link>
                        <small class="text-muted speciality">{{ item.position }}</small>
                    </div>
                </div>
            </div><!--end col-->

            <div v-if="props.show" class="col-12 mt-4 pt-2 text-center">
                <router-link to="/doctor-team-one" class="btn btn-primary">See More</router-link>
            </div><!--end col-->
        </div><!--end row-->
    </div><!--end container-->
    <!-- End -->


</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        required: true
    },
    doctors: {
        type: Boolean,
        required: true
    }
})

const datas = ref([
    {
        image: require('../../assets/images/doctors/01.jpg'),
        name: 'Calvin Carlo',
        position: 'Eye Care'
    },
    {
        image: require('../../assets/images/doctors/02.jpg'),
        name: 'Cristino Murphy',
        position: 'Gynecology'
    },
    {
        image: require('../../assets/images/doctors/03.jpg'),
        name: 'Alia Reddy',
        position: 'Psychotherapy'
    },
    {
        image: require('../../assets/images/doctors/04.jpg'),
        name: 'Toni Kovar',
        position: 'Orthopedic'
    },
    {
        image: require('../../assets/images/doctors/05.jpg'),
        name: 'Jessica McFarlane',
        position: 'Dentist'
    },
    {
        image: require('../../assets/images/doctors/06.jpg'),
        name: 'Elsie Sherman',
        position: 'Gastrologist'
    },
    {
        image: require('../../assets/images/doctors/07.jpg'),
        name: 'Bertha Magers',
        position: 'Urologist'
    },
    {
        image: require('../../assets/images/doctors/08.jpg'),
        name: 'Louis Batey',
        position: 'Neurologist'
    },
])
</script>

<style lang="scss" scoped></style>